var map = {
	"./1-blue-circle.png": 856,
	"./1-blue-cross.png": 857,
	"./1-blue-star.png": 858,
	"./1-blue-triangle.png": 859,
	"./1-green-circle.png": 860,
	"./1-green-cross.png": 861,
	"./1-green-star.png": 862,
	"./1-green-triangle.png": 863,
	"./1-red-circle.png": 864,
	"./1-red-cross.png": 865,
	"./1-red-star.png": 866,
	"./1-red-triangle.png": 295,
	"./1-yellow-circle.png": 867,
	"./1-yellow-cross.png": 868,
	"./1-yellow-star.png": 869,
	"./1-yellow-triangle.png": 870,
	"./2-blue-circle.png": 871,
	"./2-blue-cross.png": 872,
	"./2-blue-star.png": 873,
	"./2-blue-triangle.png": 874,
	"./2-green-circle.png": 875,
	"./2-green-cross.png": 876,
	"./2-green-star.png": 296,
	"./2-green-triangle.png": 877,
	"./2-red-circle.png": 878,
	"./2-red-cross.png": 879,
	"./2-red-star.png": 880,
	"./2-red-triangle.png": 881,
	"./2-yellow-circle.png": 882,
	"./2-yellow-cross.png": 883,
	"./2-yellow-star.png": 884,
	"./2-yellow-triangle.png": 885,
	"./3-blue-circle.png": 886,
	"./3-blue-cross.png": 887,
	"./3-blue-star.png": 888,
	"./3-blue-triangle.png": 889,
	"./3-green-circle.png": 890,
	"./3-green-cross.png": 891,
	"./3-green-star.png": 892,
	"./3-green-triangle.png": 893,
	"./3-red-circle.png": 894,
	"./3-red-cross.png": 895,
	"./3-red-star.png": 896,
	"./3-red-triangle.png": 897,
	"./3-yellow-circle.png": 898,
	"./3-yellow-cross.png": 297,
	"./3-yellow-star.png": 899,
	"./3-yellow-triangle.png": 900,
	"./4-blue-circle.png": 298,
	"./4-blue-cross.png": 901,
	"./4-blue-star.png": 902,
	"./4-blue-triangle.png": 903,
	"./4-green-circle.png": 904,
	"./4-green-cross.png": 905,
	"./4-green-star.png": 906,
	"./4-green-triangle.png": 907,
	"./4-red-circle.png": 908,
	"./4-red-cross.png": 909,
	"./4-red-star.png": 910,
	"./4-red-triangle.png": 911,
	"./4-yellow-circle.png": 912,
	"./4-yellow-cross.png": 913,
	"./4-yellow-star.png": 914,
	"./4-yellow-triangle.png": 915
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 855;